module.exports = "/fonts/vendor/boxicons/boxicons.eot?65a8ce52fc5427e8f94dcc5845d439ec";